import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { WithMfeRemote } from '@pedidosya/web-mfe';
import CountryShortNameContext from '@providers/CountryShortNameContext';

import Skeleton from '@pedidosya/web-fenix/system/Skeleton';

const remotes = [
  {
    id: 'webfooter',
    remoteEntry:
      'https://live.pystatic.com/webassets/AppscoreWeb/footer-web/v4/remoteEntry.js',
    moduleName: 'Footer',
  },
];

const MfeRemote = WithMfeRemote(remotes);

const MfeComponent = ({ countryCode }) => (
  <MfeRemote
    id="webfooter"
    countryCode={countryCode}
    loading={<Skeleton height="shape-size-action-64" />}
    fallback={null}
  />
);

const FooterParcel = () => {
  const countryShortName = useContext(CountryShortNameContext);

  return <MfeComponent countryCode={countryShortName} />;
};

MfeComponent.propTypes = {
  countryCode: PropTypes.string,
};

export default FooterParcel;
